(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atc-modal"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
    $('.indigo_popup_close, .cancel_color').on('click', function (e) {
      e.preventDefault();
      if ($('#footer-atc')) {
        if ($('#footer-atc').hasClass('block_it')) {
          $('.indigo_check_container').removeClass('show_indigo_container');
          $('#footer-atc').removeClass('block_it');
          $('#footer-atc').click();
          return;
        }
      }
    });

    $('#indigo_form').on('submit', function (event) {
      event.preventDefault();
      const formData = new FormData(event.target);
      const ffnId = formData.get('memberid');
      if (!ffnId || ffnId === '') {
        $('.indigo_error').html('<sup>**</sup> Member id is required!!');
        return false;
      }
      if (ffnId.length !== 9) {
        $('.indigo_error').html('<sup>**</sup> Enter a valid member id!!');
        return false;
      }
      $('.indigo_error').html('');
      fetch(`https://api.iplanet.one/indigo/membership/getmember`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: ffnId,
        }),
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          if (response.success === true) {
            $('.indigo_error').html('');
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  member_id: ffnId,
                },
              }),
            });
            $('.indigo_popup_close').click();
          } else {
            $('.indigo_error').html('<sup>**</sup> Please enter an valid membership number!!');
            fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                attributes: {
                  member_id: "",
                },
              }),
            });
          }
        })
        .catch((error) => {
          $('.indigo_error').html(`<sup>**</sup> ${error.message ?? 'An error occured!!'}`);
        });
    });
    $('.indigo_check_container').on('click', function (event) {
      if ($(event.target).closest('.indigo_check_main').length) {
        return;
      }
      $('.indigo_check_container').removeClass('show_indigo_container');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
